import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addApproveReason, deleteApproveReason, getAllApproveReason, updateApproveReason } from '../../redux/rtk/features/masters/approveReasonSlice';
import PageTitle from '../page-header/PageHeader';

const ApproveReasonMaster = () => {
  const { Title } = Typography;
  const [editingApproveReason, setEditingApproveReason] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.approveReason);

  useEffect(() => {
    dispatch(getAllApproveReason());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingApproveReason) {
        // Update existing approveReason
        const result = await dispatch(
          updateApproveReason({ id: editingApproveReason.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllApproveReason());
        } else {
          // message.error('Error updating approveReason!');
        }
      } else {
        // Add new approveReason
        const result = await dispatch(addApproveReason(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllApproveReason());
        } else {
          // message.error('Error adding approveReason!');
        }
      }
      setEditingApproveReason(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update approve reason!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteApproveReason(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllApproveReason());
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Approve Reason',
      dataIndex: 'approveReason',
      key: 'approveReason',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingApproveReason(record); form.setFieldsValue(record);}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this approve reason?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
        <Card title={editingApproveReason ? 'Edit Approve Reason' : 'Add Approve Reason'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="approve-reason-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="approveReason"
            label="Approve Reason"
            rules={[{ required: true, message: 'Please enter a approve reason !' }]}
          >
            <Input placeholder="Enter approve reason" />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingApproveReason ? 'Update Approve Reason' : 'Add Approve Reason'}
              </Button>
            </Form>
        </Card>
        </Col>
        <Col span={16}>
          <Card title="Approve Reason List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
        </Row>
    </div>
  );
};

export default ApproveReasonMaster;
